import * as t from 'typed-contracts';

export function validate(validator) {
  return (value) => {
    const validationResult = validator(value);
    if (validationResult instanceof t.ValidationError) {
      throw validationResult;
    }
    return validationResult;
  };
}
